package one.healthium.domain.user.models

data class UserProfileOptions(
    val name: String? = null,
    val age: Int? = null,
    val weight: Float? = null,
    val targetWeight: Float? = null,
    val height: Float? = null,
    val additionalInfo: Map<String, List<AdditionalUserInfoModel>>? = null,
    val avatarUrl: String? = null,
)
